import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SparklesIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon className={className} size={size} color={color} onClick={onClick}>
      <path
        d="M30.3984 11.0827L23.7916 8.20958L20.9167 1.60092C20.5989 0.871716 19.4011 0.871716 19.0833 1.60092L16.2096 8.20958L9.60093 11.0827C9.2364 11.2415 9 11.6021 9 12C9 12.3978 9.23627 12.7584 9.60093 12.9173L16.2096 15.7904L19.0833 22.3985C19.2421 22.7644 19.6016 23.0001 20 23.0001C20.3984 23.0001 20.7579 22.7644 20.9167 22.3985L23.7916 15.7904L30.3984 12.9173C30.7643 12.7585 31 12.3978 31 12C31 11.6021 30.7643 11.2416 30.3984 11.0827ZM22.6328 14.1133C22.3997 14.2142 22.2148 14.3997 22.1145 14.6316L20 19.4922L17.8867 14.6316C17.7851 14.3998 17.6003 14.2142 17.3684 14.1133L12.5077 12L17.3684 9.88665C17.6001 9.78572 17.7851 9.60025 17.8867 9.36838L20 4.50705L22.1145 9.36838C22.2148 9.60012 22.3997 9.78572 22.6328 9.88665L27.4921 12L22.6328 14.1133Z"
        fill="#FEFEFE"
      />
      <path
        d="M15.7317 22.4166L11.4465 20.5533L9.58386 16.2681C9.26612 15.5376 8.06693 15.5376 7.74919 16.2681L5.88652 20.5533L1.60133 22.4166C1.23613 22.5754 0.999725 22.9349 0.999725 23.3333C0.999725 23.7317 1.23599 24.0912 1.60133 24.25L5.88652 26.1133L7.74919 30.3985C7.90799 30.7644 8.26812 31.0001 8.66652 31.0001C9.06492 31.0001 9.42492 30.7644 9.58386 30.3985L11.4465 26.1133L15.7317 24.25C16.0969 24.0912 16.3333 23.7317 16.3333 23.3333C16.3333 22.9349 16.0971 22.5754 15.7317 22.4166ZM10.2884 24.4361C10.056 24.5364 9.87039 24.7213 9.76946 24.9544L8.66666 27.4921L7.56386 24.9544C7.46292 24.7213 7.27746 24.5364 7.04492 24.4361L4.50853 23.3333L7.04492 22.2305C7.27732 22.1302 7.46292 21.9453 7.56386 21.7122L8.66666 19.1745L9.76946 21.7122C9.87039 21.9453 10.0559 22.1302 10.2884 22.2305L12.8248 23.3333L10.2884 24.4361Z"
        fill="#FEFEFE"
      />
    </BaseIcon>
  ),
);

SparklesIcon.displayName = 'SparklesIcon';
